module.exports = "/images/bracelet.svg?79a23ef479a2eebdbbff9fbed8687514";